// fetchGift.js
'use strict';
import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  ADD_GIFTS,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch gift
 * @kind action
 * @param {string} {id} - action param.
 * @return {Promise} Action promise.
 */
const fetchGift =
  ({ giftId }) =>
  async (dispatch, getState) => {
    const selectPath = ['gift', 'item', giftId];
    const token = getMeData(getState(), 'token');
    const isFetching = getNetworkingData(getState(), selectPath, 'isFetching');
    if (isFetching) {
      return dispatch({ type: '' });
    }

    const fetchOptions = {
      headers: {
        ...getHeaders(),
        Authorization: `Bearer ${token}`,
      },
    };

    const url = getResourceUrl({ endpoint: `/gift/${giftId}` });

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      const data = await response.json();

      dispatch({ type: ADD_GIFTS, payload: { gifts: { [giftId]: data } } });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default fetchGift;
